var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#515864",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.972 3A3.015 3.015 0 0112 6.028C12 7.654 10.655 9 8.972 9A2.991 2.991 0 016 6.028C6 4.346 7.345 3 8.972 3zM3 12.353C4.291 14.647 6.552 16 8.973 16c2.475 0 4.736-1.353 6.027-3.647C14.354 10.942 13.01 10 11.556 10H6.444c-1.453 0-2.798.94-3.444 2.353z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.973 0C13.957 0 18 4.043 18 8.973A9.029 9.029 0 018.973 18C4.043 18 0 13.957 0 8.973 0 4.043 4.043 0 8.973 0zm0 1.107c-4.32 0-7.865 3.545-7.865 7.865 0 4.375 3.545 7.92 7.865 7.92a7.919 7.919 0 007.92-7.92c0-4.32-3.545-7.865-7.92-7.865z"
  }))));
}
export default SvgCircleUser;